import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "input-group mb-2" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "input-group-append" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "form-check" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input",
    type: "checkbox",
    id: "checkMajor",
    checked: "checked",
    disabled: "disabled"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label",
    for: "checkMajor"
  }, "Receive major development updates (less than 1 email per month)")
], -1)
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "checkMinor"
}, "Also receive minor development updates (about 1 email per week)", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-success"
}
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        placeholder: "Email address",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.address) = $event)),
        "aria-label": "Recipient's email address",
        disabled: _ctx.isFetching
      }, null, 8, _hoisted_2), [
        [_vModelText, _ctx.address]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "submit",
          disabled: _ctx.isFetching
        }, "Subscribe", 8, _hoisted_4)
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        class: "form-check-input",
        type: "checkbox",
        id: "checkMinor",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.minor) = $event)),
        disabled: _ctx.isFetching
      }, null, 8, _hoisted_7), [
        [_vModelCheckbox, _ctx.minor]
      ]),
      _hoisted_8
    ]),
    (_ctx.isDone && !_ctx.isFetching)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Changes saved successfully"))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, "There was an error saving your subscription"))
        ], 64))
      : _createCommentVNode("", true)
  ], 32))
}